import React from 'react';
import Input from '@dealroadshow/uikit-input';
import { IFinalFormFieldInputComponentProps } from '@framework/ui/Organisms/FinalForm/interfaces';

type TFieldInput = IFinalFormFieldInputComponentProps['input'];

const isTextFieldChanged = (value: string, previousValue: string) => (
  value?.trim() === previousValue?.trim()
);

interface IProps {
  name: string,
  dataTest: string,
  fieldComponent: React.ElementType,
  className?: string,
  label?: string,
  placeholder?: string,
  component?: React.ComponentType<any>,
  onChange?: (e: any, suggestion: any, options: any) => void,
  onBlur?: (e: any) => void,
  onFocus?: (e: any) => void,
  isNarrow?: boolean,
  parse?: (value: string) => string,
}

const TextField = (
  {
    name,
    dataTest,
    fieldComponent: Field,
    className,
    label,
    placeholder,
    component: Component = Input,
    ...props
  }: IProps,
) => {
  const handleFieldBlur = (
    input: TFieldInput,
    event: React.FocusEvent<HTMLElement> | string,
  ) => {
    const value = typeof event === 'string' ? event : (event.target as HTMLInputElement)?.value;
    input.onChange(value?.trim() || '');
    input.onBlur(event as React.FocusEvent<HTMLElement>);
  };

  return (
    // @ts-ignore
    <Field
      { ...props }
      label={ label }
      name={ name }
      placeholder={ placeholder }
      className={ className }
      dataTest={ dataTest }
      isEqual={ isTextFieldChanged }
    >
      { ({ input, ...props }: { input: TFieldInput }) => (
        <Component
          { ...props }
          // @ts-ignore
          input={ {
            ...input,
            onBlur: handleFieldBlur.bind(null, input),
          } }
        />
      ) }
    </Field>
  );
};

export default TextField;
